import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class PayrollConceptService {

  constructor(private http: HttpClient) { }

  createUpdateCategories(categoryForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'concept/save_update_category', categoryForm, OPTIONS);
  }

  getCategories() {
    return this.http.get<any>(Library.API_ENDPOINT + 'concept/get_concept_categories', OPTIONS);
  }

  createUpdateCatalog(categoryForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'concept/save_update_catalog', categoryForm, OPTIONS);
  }

  getCatalogs() {
    return this.http.get<any>(Library.API_ENDPOINT + 'concept/get_concept_catalogs', OPTIONS);
  }

  getCharges() {
    return this.http.get<any>(Library.API_ENDPOINT + 'concept/get_charges', OPTIONS);
  }

  deleteCategory(id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `concept/delete_category/${id}`, OPTIONS);
  }

  deleteCatalog(id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `concept/delete_catalog/${id}`, OPTIONS);
  }
}
